// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"388e98b3c987a32d632a","691":"97e8ee1c9509a33bbc02"}[chunkId] + ".js";
};